<div class="scale-container">
    <div class="scale-title">
        Let's scale your plan
        <i class="fa-light fa-info-circle"></i>
    </div>

    <div>
        <div class="scale-action" *ngIf="scaleStep() === 'drawHorizontal'">
            <span class="scale-action-text"> Step 1: Draw a HORIZONTAL line on the plan below </span>
            <button
                type="button"
                id="btn-cancel-horizontal-length"
                class="btn btn-bx-secondary-stroked"
                (click)="undoDrawingAndCancel('drawHorizontal')">
                Cancel
            </button>
        </div>
        <!-- Manual scale - Second Step -->
        <div class="scale-action" *ngIf="scaleStep() === 'enterHorizontal'">
            <div class="input-container">
                <span class="scale-action-text">Step 2: How long is your line?</span>
                <input
                    id="input-horizontal-length"
                    type="text"
                    appNumeric
                    [decimals]="2"
                    [imperial]="isImperial"
                    class="text-input"
                    [ngModel]="horizontalLength()"
                    (ngModelChange)="onHorizontalLengthChange($event)"
                    [ngModelOptions]="{ standalone: true }"
                    required
                    appSelectAllOnFocus />
                <select
                    id="select-scale-unit"
                    class="form-control"
                    [(ngModel)]="scaleUnit"
                    required
                    (change)="scaleUnitChanged()"
                    [ngModelOptions]="{ standalone: true }">
                    <option *ngFor="let u of supportedUnits" [value]="u">{{ u }}</option>
                </select>
                <div class="container-actions">
                    <button
                        type="button"
                        id="btn-cancel-horizontal-length"
                        class="btn btn-bx-secondary-stroked"
                        (click)="changeStep('drawHorizontal')">
                        Cancel
                    </button>
                    <button
                        type="button"
                        id="btn-apply-horizontal-length"
                        class="btn btn-bx-secondary-stroked"
                        [disabled]="!horizontalLength()"
                        (click)="submitHorizontalScale()">
                        Next
                    </button>
                </div>
            </div>
        </div>

        <div class="scale-action" *ngIf="scaleStep() === 'drawVertical'">
            <span class="scale-action-text">Step 3: Draw a VERTICAL line on the plan below:</span>
            <button
                type="button"
                id="btn-cancel-vertical-drawing"
                class="btn btn-bx-secondary-stroked margin-left-15"
                (click)="resetScaleStep()">
                Cancel
            </button>
        </div>
        <div class="input-container" *ngIf="scaleStep() === 'enterVertical'">
            <span class="scale-action-text">Step 4: How long is your line?</span>

            <input
                id="input-vertical-length"
                type="text"
                appNumeric
                [decimals]="2"
                [imperial]="isImperial"
                class="text-input"
                [ngModel]="verticalLength()"
                (ngModelChange)="onVerticalLengthChange($event)"
                [ngModelOptions]="{ standalone: true }"
                required
                appSelectAllOnFocus />

            <select
                class="form-control"
                id="select-scale-unit-vertical"
                [(ngModel)]="scaleUnit"
                required
                disabled
                [ngModelOptions]="{ standalone: true }">
                <option *ngFor="let u of supportedUnits" [value]="u">{{ u }}</option>
            </select>

            <div class="container-actions">
                <button
                    type="button"
                    id="btn-cancel-vertical-length"
                    class="btn btn-bx-secondary-stroked"
                    (click)="changeStep('drawVertical')">
                    Cancel
                </button>
                <div class="divider"></div>
                <button
                    type="button"
                    id="btn-apply-vertical-scale-all"
                    class="btn btn-bx-secondary-stroked"
                    [disabled]="!verticalLength()"
                    (click)="submitVerticalScale('this')">
                    Apply to this plan
                </button>
                <button
                    id="btn-apply-vertical-scale-all"
                    type="button"
                    class="btn btn-bx-secondary-stroked"
                    *ngIf="plansLength() > 1"
                    [disabled]="!verticalLength()"
                    (click)="submitVerticalScale('all')">
                    Apply to all plans
                </button>
            </div>
        </div>
    </div>

    <div>
        <button type="button" id="btn-close-scale" class="btn btn-bx-secondary-stroked" (click)="close()">Save and close</button>
    </div>
</div>
